module.exports = __webpack_public_path__ + "img/preview-8.dc5e08be.webp";